import moment from 'moment';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bounce, toast } from 'react-toastify';
import { SubscriptionModal } from '../Subscription/SubscriptionModal';
import { apiConstants } from '../_constants';
import { isNotExpired, trimString } from '../_services/misc.service';
import { subscriptionService } from '../_services/subscription.service';

export const SeriesItem = ({ seriesData }) => {
  const navigate = useNavigate();
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState({});
  //   const [showGuidLines, setShowGuidLines] = useState(false);
  // condition for subscribed or not

  //   useEffect(() => {
  //     handleSubscriptionData();
  //   }, []);

  const onSubscribe = () => {
    subscriptionService
      .subscriptionList({ series_id: seriesData._id, status: 1, isactive: 1 })
      .then(
        (res) => {
          if (res?.data?.rows?.length) {
            setSubscriptionData(res.data.rows[0]);
            setShowSubscriptionModal(true);
          } else {
            toast.error('You have no subscription plan available at this time!', {
              position: 'bottom-left',
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'dark',
              transition: Bounce,
            });
          }
        },
        (err) => {
          console.log('onSubscribeErrrr-----------', err);
        },
      );
  };
  const checkSubscription = (item) => {
    let notExpired = isNotExpired(item?.expiry_date);

    if (
      !item?.is_paid ||
      (item?.is_paid && item?.isSubscribe && item?.payment_status == 1 && notExpired)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const checkRetest = (item) => {
    const questionCount = parseInt(item?.mocktestcount);
    const answerCount = parseInt(item?.answercount);
    if (answerCount > 0 && answerCount >= questionCount) {
      return true;
    } else {
      return false;
    }
  };
  return (
    <div className='mocktextbox'>
      <img
        src={seriesData?.image ? apiConstants.imgUrl + seriesData.image : '/img/exam_dummy.jpeg'}
        className='mocktexticon'
        onClick={() => {
          navigate('/series_single', { state: { seriesData: seriesData } });
        }}
        style={{ cursor: 'pointer' }}
      />
      <div className='seriesheadtxt'>{trimString(seriesData?.series_name, 30)}</div>
      <div className='d-flex gap-2 align-items-center'>
        <div className='language'>Arabic</div>
        <div className='divider' />
        <div className='language'> {seriesData?.total_exams} Exams</div>
      </div>
      <div className='d-flex gap-2 align-items-center'>
        <div className='language'>{moment(seriesData.from_date).format('YYYY-MMM-DD')}</div>
        <div className='divider' />
        <div className='language'>
          {seriesData?.is_paid
            ? `₹ ${seriesData?.amount ? seriesData?.amount : 'Unavailable'}`
            : 'Free'}
        </div>
      </div>

      {checkSubscription(seriesData) ? (
        <div className='d-flex gap-2'>
          {((checkRetest(seriesData) && seriesData.is_repeat) || !checkRetest(seriesData)) && (
            <div
              className='seriesviewbtn seriesbtnlbl'
              onClick={() => {
                navigate('/series_single', {
                  state: { seriesData: seriesData, isSubscribed: true },
                });
                // setShowGuidLines(true);
              }}
            >
              {seriesData?.payment_status == 1 ? 'My Series Test' : 'View Series'}
            </div>
          )}
        </div>
      ) : (
        <div className='d-flex gap-2'>
          <div
            className='seriesviewbtn seriesbtnlbl'
            onClick={() => {
              navigate('/series_single', {
                state: { seriesData: seriesData, isSubscribed: false },
              });
            }}
          >
            View Series
          </div>
          <div
            className='seriesviewbtn seriesbtnlbl'
            onClick={() => {
              onSubscribe();
            }}
          >
            Subscribe
          </div>
        </div>
      )}

      <SubscriptionModal
        setShowModal={setShowSubscriptionModal}
        showModal={showSubscriptionModal}
        data={seriesData}
        subscriptionData={subscriptionData}
        type={'Test'}
      />
    </div>
  );
};
